module.exports = __webpack_public_path__ + "static/media/video-placeholder.6eec7ad1.jpg";